import React from "react";

/**
 * Word Gumbo Learning Co. — Brand Logo (real artwork, transparent PNG)
 * The `showWordmark` prop is accepted for API compatibility but the PNG
 * always includes the full wordmark, so we just render the image.
 */
export default function Logo({ className = "h-14 w-auto", alt = "Word Gumbo Learning Co. logo" }) {
  return (
    <img
      src="/wordgumbo-logo.png"
      alt={alt}
      className={className}
      loading="eager"
      decoding="async"
    />
  );
}
